<template>
  <div id="page-xls">

    <header class="bg-teal-700 py-1">
      <div class="container">
        <div class="row">
          <div class="col-6 pt-2">
            <h5 class="float-left font-weight-bold color-white">XLSX</h5>
          </div>
          <div class="col-6">
            <button class="btn btn-success float-right"
                    @click="downloadXls">
              <span class="mdi mdi-download-circle"></span>
              <span class="d-none d-md-inline"> Download</span>
            </button>
          </div>
        </div>
      </div>
    </header>

    <!--    <div class="row">
      <div class="col-12">
        <table class="table table-striped table-hover table-condensed table-responsive">
          <thead>
            <tr>
              <th v-for="(item, idx) in excelData.header"
                  :key="idx">
                {{ item }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, idx) in excelData.results"
                :key="idx">
              <td v-for="(key, i) in item"
                  :key="i">
                {{ key }}<br>{{ item.key }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>-->
    <div id="xls-table-wrapp"
         v-html="excelData.html"></div>

  </div>
</template>

<script>
  import XLSX from 'xlsx';
  import { ApiFiscalDocs } from '@/services/api';

  export default {
    name: 'XlsView',
    components: {},

    data() {
      return {
        docId: this.$route.query.id,
        workbook: null,
        excelData: {
          header: null,
          results: null,
          html: null
        }
      };
    },

    async mounted() {
      await this.getXls();
    },

    methods: {

      async getXls() {
        const data = await ApiFiscalDocs.ZReport.getXls(this.docId);

        const fileReader = new window.FileReader();
        fileReader.readAsArrayBuffer(data);
        fileReader.onloadend = async () => {

          const workbook = await XLSX.read(fileReader.result, {
            type: 'array',
            raw: true
          });

          this.workbook = workbook;

          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];

          const results = await XLSX.utils.sheet_to_json(worksheet, {
            blankrows: false,
            defval: '',
            header: 'A',
            raw: true,
            rawNumbers: true
          });

          const html = await XLSX.utils.sheet_to_html(worksheet, {
            editable: false,
            id: 'xls-table',
            header: '',
            footer: '',
            raw: true
          });

          const header = await this.getHeaderRow(worksheet);

          this.generateData(header, results, html);
        };
        // const results = await XLSX.utils.sheet_to_json(worksheet);
      },

      generateData(header, results, html) {
        this.excelData.header = header;
        this.excelData.results = results;
        this.excelData.html = html;
      },

      downloadXls() {
        ApiFiscalDocs.ZReport.downLoadXls(this.docId);

        // const link = document.createElement('a');
        // const contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8';

        /*
        link.href = window.URL.createObjectURL(new Blob([this.workbook], { type: contentType }));
        link.download = 'test2.xlsx';
        link.click(); */

        /*
        const blob = new Blob([this.workbook], { type: contentType });
        saveAs(blob, 'Export2.xlsx');
      */

        /* const file = new File([this.workbook], 'Export3.xlsx', {
          type: contentType
        });

        saveAs(file); */

        // XLSX.writeFile(this.workbook, 'out.xlsx');

        /* const wopts = { bookType: 'xlsx', bookSST: false, type: 'array' };
        const wbout = XLSX.write(this.workbook, wopts);

        saveAs(new Blob([wbout], { type: contentType }), 'sheet.xlsx'); */


        /* const blob = new Blob([this.workbook], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
        });
        saveAs(blob, 'test.xlsx'); */
      },

      async getHeaderRow(sheet) {
        const headers = [];
        const range = XLSX.utils.decode_range(sheet['!ref']);
        let C;
        const R = range.s.r; /* start in the first row */
        for (C = range.s.c; C <= range.e.c; ++C) { /* walk every column in the range */
          const cell = sheet[XLSX.utils.encode_cell({
            c: C,
            r: R
          })]; /* find the cell in the first row */
          let hdr = 'UNKNOWN ' + C; // <-- replace with your desired default
          if (cell && cell.t) hdr = XLSX.utils.format_cell(cell);

          headers.push(hdr);
        }

        return headers;
      }
    }

  };

</script>

<style lang="stylus" scoped>

header {

}

#xls-table-wrapp {
  overflow auto
  padding 10px
  background: #f6f6f6
}

#xls-table {
  width: 100%

  tr:nth-child(even) {
    background-color: #fff;
  }

  tr:nth-child(odd) {
    background-color: #ececec;
  }

  td {
    border: 1px solid #ccc !important;
    text-align center
    vertical-align middle
    padding 3px 3px

    font-size 14px
  }
}


</style>
